import React from 'react';
import { Card, Row, Col, Statistic, Typography, Progress } from 'antd';
import {
  LineChartOutlined,
  ToolOutlined,
  DashboardOutlined,
  ClockCircleOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const MFGAnalytics: React.FC = () => {
  return (
    <div>
      <Title level={2}>
        <LineChartOutlined /> Manufacturing Analytics
      </Title>
      <Paragraph>Production performance metrics and manufacturing insights.</Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Production Efficiency"
              value={87.5}
              precision={1}
              suffix="%"
              prefix={<ThunderboltOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Work Orders"
              value={145}
              prefix={<ToolOutlined />}
              valueStyle={{ color: '#145A54' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Capacity Utilization"
              value={78.3}
              precision={1}
              suffix="%"
              prefix={<DashboardOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Avg Cycle Time"
              value={4.2}
              precision={1}
              suffix="hrs"
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Production Performance" bordered={false}>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                <span>Overall Equipment Effectiveness (OEE)</span>
                <Progress percent={85.0} status="active" strokeColor="#145A54" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>First Pass Yield</span>
                <Progress percent={92.5} status="active" strokeColor="#52c41a" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>Downtime %</span>
                <Progress percent={8.5} status="exception" strokeColor="#ff4d4f" />
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Production Output" bordered={false}>
            <Paragraph>Daily/weekly production output trends would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="Work Center Performance" bordered={false}>
            <Paragraph>Performance comparison across work centers would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MFGAnalytics;
